module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_06-8f24aca6b99ac1a6a5ea294187698e16.jpg";